<header class="nw-page-heading__container">
    @if (logo) {
        <img class="nw-page-heading__container__logo" [src]="logo" alt="logo" />
    }

    <h1 [innerHTML]="heading | highlightText"></h1>
    @if (!islandingpage) {
        <div class="nw-page-heading__container__underline"></div>
    }
    @if (subheading) {
        <p class="nw-page-heading__container__sub-heading">{{ subheading }}</p>
    }
    @if (calltoaction) {
        <a
            class="nw-page-heading__container__call-to-action nw-button"
            [href]="calltoaction.path"
            >{{ calltoaction.label }}</a
        >
    }
</header>
